var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityEditCard',{attrs:{"title":_vm.$t('servicesystem.common_objects.commonterms.details'),"item":_vm.machineModel,"saveMethod":_vm.saveMethod},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var editMode = ref.editMode;
var setEditMode = ref.setEditMode;
return [_c('div'),_c('v-btn',{staticStyle:{"position":"absolute","z-index":"30","right":"8px","top":"8px"},attrs:{"icon":"","small":""},on:{"click":function($event){return setEditMode(!editMode)}}},[_c('v-icon',{domProps:{"textContent":_vm._s(editMode ? 'mdi-close' : 'mdi-pencil')}})],1)]}},{key:"content",fn:function(ref){
var item = ref.item;
var editMode = ref.editMode;
var edittrigger = ref.edittrigger;
var handleFocus = ref.handleFocus;
return [_c('MachineModelEditContent',{staticClass:"pr-6",attrs:{"item":item,"editMode":editMode,"edittrigger":edittrigger,"handleFocus":handleFocus}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }